import { Button, Stack, StackProps, ThemeTypings, Text, HStack, ThemingProps } from "@chakra-ui/react"
import { size } from "lodash"
import { FaPlus } from "react-icons/fa"
import { useDispatch } from "react-redux"
import { showConfirmDialog } from "../../../store/reducers/confirm-modal"


interface SectionCardProps extends StackProps {
    children: any
    title?: string,
    subTitle?: string,
    creatable?: SectionCardCreatable,
    backgroundColor?: string
    actions?: any
}

export type SectionCardCreatable = {
    text?: string | undefined,
    onClick: any,
    backgroundColor?: string,
    isLoading?: boolean,
    buttonColorScheme?: ThemeTypings["colorSchemes"]
}

type PageHeaderAction = {
    text: string,
    onClick: () => any,
    isDisabled?: boolean,
    confirmation?: boolean,
    buttonColorScheme?: ThemeTypings["colorSchemes"]
    buttonVariant?: ThemingProps<"Button">["variant"]
}

const EMPTY_FUNC = () => { }

export const SectionCard = ({ title, children, subTitle, creatable, actions = [], backgroundColor, ...rest }: SectionCardProps) => {
    const dispatch = useDispatch()

    const onClickHandler = (confirm: Boolean | undefined, action: Function) => {
        if (confirm || confirm === undefined || confirm === null) {
            dispatch(
                showConfirmDialog({
                    title: "Confirmation Required!",
                    subtitle: "Are you sure you want to continue the action?",
                    onConfirm: action || (() => { })
                }))

        } else {
            action()
        }

    }

    const actionMarkup = actions.map((action: PageHeaderAction, index: number) =>
        <Button key={index} colorScheme={action.buttonColorScheme || "blackAlpha"} size={"sm"} isDisabled={Boolean(action.isDisabled)}
            variant={action.buttonVariant || 'outline'} onClick={() => { onClickHandler(action?.confirmation, action.onClick) }}>
            {action.text}
        </Button>)


    return (
        <Stack gap={0} className={`border rounded mt-4 ${backgroundColor ? backgroundColor : 'bg-slate-50'}  p-3 transition-all`} {...rest}>
            <div className="flex justify-between items-center">
                <div className="flex flex-col py-1">
                    {title && <p className="font-semibold !p-0 !m-0">{title}</p>}
                    {subTitle && <p className="font-medium !p-0 !m-0 mb-2">{subTitle}</p>}
                </div>

                {creatable && (<Button size={'sm'} aria-label="Add new" isDisabled={creatable?.isLoading} onClick={creatable?.onClick || EMPTY_FUNC} colorScheme={creatable?.buttonColorScheme || 'teal'} leftIcon={<FaPlus />}>
                    <HStack alignItems={"center"}>
                        <Text>{creatable?.text || 'New'}</Text>
                    </HStack>
                </Button>)}

                {(actions && size(actions) > 0) && (
                    <HStack alignItems={"center"}>
                        {actionMarkup}
                    </HStack>
                )}
            </div>
            <div className="mt-2">
                {children}
            </div>
        </Stack>
    )
}